module.exports = __webpack_public_path__ + "pc/img/swiper_logo_dorco.307721cb.png";